import React from 'react'
import { Link } from 'react-router-dom'
import { useSeo } from '../../lib/i18n'

export default function NotFoundPageEn() {
  useSeo({
    title: '404 Page Not Found - Borgs Driving School',
    description: 'The page you are looking for does not exist at Borgs Driving School.',
    lang: 'en',
    pathname: '/en/404'
  })

  return (
    <div className="bg-slate-50 min-h-[70vh] flex items-center justify-center py-20 px-4">
      <div className="max-w-md w-full text-center bg-white p-8 sm:p-10 rounded-3xl border border-slate-200 shadow-xl space-y-6">
        <div className="w-20 h-20 rounded-3xl bg-emerald-100 text-emerald-700 mx-auto flex items-center justify-center text-3xl font-bold">
          <i className="fa-solid fa-triangle-exclamation" aria-hidden="true"></i>
        </div>

        <div>
          <span className="text-emerald-600 font-extrabold text-sm uppercase tracking-wider block mb-1">
            Error code 404
          </span>
          <h1 className="font-header text-3xl font-extrabold text-slate-900">
            Page Not Found
          </h1>
          <p className="mt-2 text-slate-600 text-sm leading-relaxed">
            The page you tried to reach does not exist or has been moved.
          </p>
        </div>

        <div className="pt-2 flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/en"
            className="w-full sm:w-auto px-6 py-3 rounded-full bg-emerald-600 hover:bg-emerald-700 text-white font-bold text-sm shadow-md transition-colors inline-flex items-center justify-center gap-2"
          >
            <i className="fa-solid fa-house" aria-hidden="true"></i>
            <span>Go to Home</span>
          </Link>

          <Link
            to="/en/contact"
            className="w-full sm:w-auto px-6 py-3 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-800 font-bold text-sm transition-colors"
          >
            Contact Us
          </Link>
        </div>
      </div>
    </div>
  )
}
